import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { datePickerInjectionKey as Et } from "./interface.js";
import zt from "./panel/date.js";
import Mt from "./panel/daterange.js";
import Ut from "./panel/datetime.js";
import At from "./panel/datetimerange.js";
import jt from "./panel/month.js";
import Bt from "./panel/monthrange.js";
import { datePickerProps as Ht } from "./props.js";
import Yt from "./styles/index.cssr.js";
import { strictParse as I } from "./utils.js";
import { uniCalendarValidation as _t, dualCalendarValidation as Nt } from "./validation-utils.js";
import qt from "../../_mixins/use-locale.js";
import Kt from "../../_mixins/use-form-item.js";
import $t from "../../_mixins/use-config.js";
import oe from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-merged-state.js";
import Wt from "../../_mixins/use-theme.js";
import { warn as Lt, warnOnce as Gt } from "../../_utils/naive/warn.js";
import { useThemeClass as de } from "../../_mixins/use-css-vars-class.js";
import { createKey as se } from "../../_utils/cssr/index.js";
import Jt from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/life-cycle/use-is-mounted.js";
import ue from "../../input/src/Input.js";
import { resolveSlot as q } from "../../_utils/vue/resolve-slot.js";
import K from "../../_internal/icon/src/Icon.js";
import Qt from "../../../../../../vdirs@0.1.8_vue@3.5.18/node_modules/vdirs/es/clickoutside.js";
import Xt from "../styles/light.js";
import { markEventEffectPerformed as ce } from "../../_utils/event/index.js";
import { getPreciseEventTarget as Zt } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/dom/get-precise-event-target.js";
import { happensIn as ea } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/dom/happens-in.js";
import ta from "../../_internal/icons/To.js";
import me from "../../_internal/icons/Date.js";
import { call as v } from "../../_utils/vue/call.js";
import { defineComponent as aa, watchEffect as fe, computed as s, watch as he, provide as na, h as o, withDirectives as ra } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as p, toRef as m } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { useAdjustedTo as ge } from "../../_utils/composable/use-adjusted-to.js";
import ia from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/binder/src/Binder.js";
import la from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/binder/src/Target.js";
import oa from "../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/binder/src/Follower.js";
import { Transition as da } from "../../../../../../@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { formatDate as k } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/format.js";
import { isValid as $ } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/isValid.js";
import { getTime as W } from "../../../../../../date-fns@3.6.0/node_modules/date-fns/getTime.js";
const Qa = aa({
  name: "DatePicker",
  props: Ht,
  slots: Object,
  setup(t, {
    slots: O
  }) {
    var d;
    process.env.NODE_ENV !== "production" && fe(() => {
      t.onChange !== void 0 && Gt("date-picker", "`on-change` is deprecated, please use `on-update:value` instead.");
    });
    const {
      localeRef: r,
      dateLocaleRef: f
    } = qt("DatePicker"), P = Kt(t), {
      mergedSizeRef: M,
      mergedDisabledRef: l,
      mergedStatusRef: ve
    } = P, {
      mergedComponentPropsRef: j,
      mergedClsPrefixRef: B,
      mergedBorderedRef: pe,
      namespaceRef: Ce,
      inlineThemeDisabled: U
    } = $t(t), L = p(null), G = p(null), F = p(null), J = p(!1), Pe = m(t, "show"), h = oe(Pe, J), g = s(() => ({
      locale: f.value.locale,
      useAdditionalWeekYearTokens: !0
    })), y = s(() => {
      const {
        format: e
      } = t;
      if (e)
        return e;
      switch (t.type) {
        case "date":
        case "daterange":
          return r.value.dateFormat;
        case "datetime":
        case "datetimerange":
          return r.value.dateTimeFormat;
        case "year":
        case "yearrange":
          return r.value.yearTypeFormat;
        case "month":
        case "monthrange":
          return r.value.monthTypeFormat;
        case "quarter":
        case "quarterrange":
          return r.value.quarterFormat;
        case "week":
          return r.value.weekFormat;
      }
    }), H = s(() => {
      var e;
      return (e = t.valueFormat) !== null && e !== void 0 ? e : y.value;
    });
    function Q(e) {
      if (e === null)
        return null;
      const {
        value: a
      } = H, {
        value: n
      } = g;
      return Array.isArray(e) ? [I(e[0], a, /* @__PURE__ */ new Date(), n).getTime(), I(e[1], a, /* @__PURE__ */ new Date(), n).getTime()] : I(e, a, /* @__PURE__ */ new Date(), n).getTime();
    }
    const {
      defaultFormattedValue: X,
      defaultValue: ye
    } = t, Y = p((d = X !== void 0 ? Q(X) : ye) !== null && d !== void 0 ? d : null), Te = s(() => {
      const {
        formattedValue: e
      } = t;
      return e !== void 0 ? Q(e) : t.value;
    }), Z = oe(Te, Y), u = p(null);
    fe(() => {
      u.value = Z.value;
    });
    const x = p(""), E = p(""), z = p(""), A = Wt("DatePicker", "-date-picker", Yt, Xt, t, B), Re = s(() => {
      var e, a;
      return ((a = (e = j == null ? void 0 : j.value) === null || e === void 0 ? void 0 : e.DatePicker) === null || a === void 0 ? void 0 : a.timePickerSize) || "small";
    }), ee = s(() => ["daterange", "datetimerange", "monthrange", "quarterrange", "yearrange"].includes(t.type)), Fe = s(() => {
      const {
        placeholder: e
      } = t;
      if (e === void 0) {
        const {
          type: a
        } = t;
        switch (a) {
          case "date":
            return r.value.datePlaceholder;
          case "datetime":
            return r.value.datetimePlaceholder;
          case "month":
            return r.value.monthPlaceholder;
          case "year":
            return r.value.yearPlaceholder;
          case "quarter":
            return r.value.quarterPlaceholder;
          case "week":
            return r.value.weekPlaceholder;
          default:
            return "";
        }
      } else
        return e;
    }), Ve = s(() => t.startPlaceholder === void 0 ? t.type === "daterange" ? r.value.startDatePlaceholder : t.type === "datetimerange" ? r.value.startDatetimePlaceholder : t.type === "monthrange" ? r.value.startMonthPlaceholder : "" : t.startPlaceholder), we = s(() => t.endPlaceholder === void 0 ? t.type === "daterange" ? r.value.endDatePlaceholder : t.type === "datetimerange" ? r.value.endDatetimePlaceholder : t.type === "monthrange" ? r.value.endMonthPlaceholder : "" : t.endPlaceholder), Se = s(() => {
      const {
        actions: e,
        type: a,
        clearable: n
      } = t;
      if (e === null)
        return [];
      if (e !== void 0)
        return e;
      const i = n ? ["clear"] : [];
      switch (a) {
        case "date":
        case "week":
          return i.push("now"), i;
        case "datetime":
          return i.push("now", "confirm"), i;
        case "daterange":
          return i.push("confirm"), i;
        case "datetimerange":
          return i.push("confirm"), i;
        case "month":
          return i.push("now", "confirm"), i;
        case "year":
          return i.push("now"), i;
        case "quarter":
          return i.push("now", "confirm"), i;
        case "monthrange":
        case "yearrange":
        case "quarterrange":
          return i.push("confirm"), i;
        default: {
          Lt("date-picker", "The type is wrong, n-date-picker's type only supports `date`, `datetime`, `daterange` and `datetimerange`.");
          break;
        }
      }
    });
    function De(e) {
      if (e === null)
        return null;
      if (Array.isArray(e)) {
        const {
          value: a
        } = H, {
          value: n
        } = g;
        return [k(e[0], a, n), k(e[1], a, g.value)];
      } else
        return k(e, H.value, g.value);
    }
    function be(e) {
      u.value = e;
    }
    function Ie(e, a) {
      const {
        "onUpdate:formattedValue": n,
        onUpdateFormattedValue: i
      } = t;
      n && v(n, e, a), i && v(i, e, a);
    }
    function V(e, a) {
      const {
        "onUpdate:value": n,
        onUpdateValue: i,
        onChange: C
      } = t, {
        nTriggerFormChange: T,
        nTriggerFormInput: R
      } = P, c = De(e);
      a.doConfirm && ke(e, c), i && v(i, e, c), n && v(n, e, c), C && v(C, e, c), Y.value = e, Ie(c, e), T(), R();
    }
    function te() {
      const {
        onClear: e
      } = t;
      e == null || e();
    }
    function ke(e, a) {
      const {
        onConfirm: n
      } = t;
      n && n(e, a);
    }
    function Oe(e) {
      const {
        onFocus: a
      } = t, {
        nTriggerFormFocus: n
      } = P;
      a && v(a, e), n();
    }
    function xe(e) {
      const {
        onBlur: a
      } = t, {
        nTriggerFormBlur: n
      } = P;
      a && v(a, e), n();
    }
    function _(e) {
      const {
        "onUpdate:show": a,
        onUpdateShow: n
      } = t;
      a && v(a, e), n && v(n, e), J.value = e;
    }
    function Ee(e) {
      e.key === "Escape" && h.value && (ce(e), S({
        returnFocus: !0
      }));
    }
    function ze(e) {
      e.key === "Escape" && h.value && ce(e);
    }
    function Me() {
      var e;
      _(!1), (e = F.value) === null || e === void 0 || e.deactivate(), te();
    }
    function Ue() {
      var e;
      (e = F.value) === null || e === void 0 || e.deactivate(), te();
    }
    function Ae() {
      S({
        returnFocus: !0
      });
    }
    function je(e) {
      var a;
      h.value && !(!((a = G.value) === null || a === void 0) && a.contains(Zt(e))) && S({
        returnFocus: !1
      });
    }
    function Be(e) {
      S({
        returnFocus: !0,
        disableUpdateOnClose: e
      });
    }
    function He(e, a) {
      a ? V(e, {
        doConfirm: !1
      }) : be(e);
    }
    function ae() {
      const e = u.value;
      V(Array.isArray(e) ? [e[0], e[1]] : e, {
        doConfirm: !0
      });
    }
    function w() {
      const {
        value: e
      } = u;
      ee.value ? (Array.isArray(e) || e === null) && _e(e) : Array.isArray(e) || Ye(e);
    }
    function Ye(e) {
      e === null ? x.value = "" : x.value = k(e, y.value, g.value);
    }
    function _e(e) {
      if (e === null)
        E.value = "", z.value = "";
      else {
        const a = g.value;
        E.value = k(e[0], y.value, a), z.value = k(e[1], y.value, a);
      }
    }
    function Ne() {
      h.value || ne();
    }
    function qe(e) {
      var a;
      !((a = L.value) === null || a === void 0) && a.$el.contains(e.relatedTarget) || (xe(e), w(), S({
        returnFocus: !1
      }));
    }
    function Ke() {
      l.value || (w(), S({
        returnFocus: !1
      }));
    }
    function $e(e) {
      if (e === "") {
        V(null, {
          doConfirm: !1
        }), u.value = null, x.value = "";
        return;
      }
      const a = I(e, y.value, /* @__PURE__ */ new Date(), g.value);
      $(a) ? (V(W(a), {
        doConfirm: !1
      }), w()) : x.value = e;
    }
    function We(e, {
      source: a
    }) {
      if (e[0] === "" && e[1] === "") {
        V(null, {
          doConfirm: !1
        }), u.value = null, E.value = "", z.value = "";
        return;
      }
      const [n, i] = e, C = I(n, y.value, /* @__PURE__ */ new Date(), g.value), T = I(i, y.value, /* @__PURE__ */ new Date(), g.value);
      if ($(C) && $(T)) {
        let R = W(C), c = W(T);
        T < C && (a === 0 ? c = R : R = c), V([R, c], {
          doConfirm: !1
        }), w();
      } else
        [E.value, z.value] = e;
    }
    function Le(e) {
      l.value || ea(e, "clear") || h.value || ne();
    }
    function Ge(e) {
      l.value || Oe(e);
    }
    function ne() {
      l.value || h.value || _(!0);
    }
    function S({
      returnFocus: e,
      disableUpdateOnClose: a
    }) {
      var n;
      h.value && (_(!1), t.type !== "date" && t.updateValueOnClose && !a && ae(), e && ((n = F.value) === null || n === void 0 || n.focus()));
    }
    he(u, () => {
      w();
    }), w(), he(h, (e) => {
      e || (u.value = Z.value);
    });
    const re = _t(t, u), N = Nt(t, u);
    na(Et, Object.assign(Object.assign(Object.assign({
      mergedClsPrefixRef: B,
      mergedThemeRef: A,
      timePickerSizeRef: Re,
      localeRef: r,
      dateLocaleRef: f,
      firstDayOfWeekRef: m(t, "firstDayOfWeek"),
      isDateDisabledRef: m(t, "isDateDisabled"),
      rangesRef: m(t, "ranges"),
      timePickerPropsRef: m(t, "timePickerProps"),
      closeOnSelectRef: m(t, "closeOnSelect"),
      updateValueOnCloseRef: m(t, "updateValueOnClose"),
      monthFormatRef: m(t, "monthFormat"),
      yearFormatRef: m(t, "yearFormat"),
      quarterFormatRef: m(t, "quarterFormat"),
      yearRangeRef: m(t, "yearRange")
    }, re), N), {
      datePickerSlots: O
    }));
    const Je = {
      focus: () => {
        var e;
        (e = F.value) === null || e === void 0 || e.focus();
      },
      blur: () => {
        var e;
        (e = F.value) === null || e === void 0 || e.blur();
      }
    }, ie = s(() => {
      const {
        common: {
          cubicBezierEaseInOut: e
        },
        self: {
          iconColor: a,
          iconColorDisabled: n
        }
      } = A.value;
      return {
        "--n-bezier": e,
        "--n-icon-color-override": a,
        "--n-icon-color-disabled-override": n
      };
    }), D = U ? de("date-picker-trigger", void 0, ie, t) : void 0, le = s(() => {
      const {
        type: e
      } = t, {
        common: {
          cubicBezierEaseInOut: a
        },
        self: {
          calendarTitleFontSize: n,
          calendarDaysFontSize: i,
          itemFontSize: C,
          itemTextColor: T,
          itemColorDisabled: R,
          itemColorIncluded: c,
          itemColorHover: Qe,
          itemColorActive: Xe,
          itemBorderRadius: Ze,
          itemTextColorDisabled: et,
          itemTextColorActive: tt,
          panelColor: at,
          panelTextColor: nt,
          arrowColor: rt,
          calendarTitleTextColor: it,
          panelActionDividerColor: lt,
          panelHeaderDividerColor: ot,
          calendarDaysDividerColor: dt,
          panelBoxShadow: st,
          panelBorderRadius: ut,
          calendarTitleFontWeight: ct,
          panelExtraFooterPadding: mt,
          panelActionPadding: ft,
          itemSize: ht,
          itemCellWidth: gt,
          itemCellHeight: vt,
          scrollItemWidth: pt,
          scrollItemHeight: Ct,
          calendarTitlePadding: Pt,
          calendarTitleHeight: yt,
          calendarDaysHeight: Tt,
          calendarDaysTextColor: Rt,
          arrowSize: Ft,
          panelHeaderPadding: Vt,
          calendarDividerColor: wt,
          calendarTitleGridTempateColumns: St,
          iconColor: Dt,
          iconColorDisabled: bt,
          scrollItemBorderRadius: It,
          calendarTitleColorHover: kt,
          [se("calendarLeftPadding", e)]: Ot,
          [se("calendarRightPadding", e)]: xt
        }
      } = A.value;
      return {
        "--n-bezier": a,
        "--n-panel-border-radius": ut,
        "--n-panel-color": at,
        "--n-panel-box-shadow": st,
        "--n-panel-text-color": nt,
        // panel header
        "--n-panel-header-padding": Vt,
        "--n-panel-header-divider-color": ot,
        // panel calendar
        "--n-calendar-left-padding": Ot,
        "--n-calendar-right-padding": xt,
        "--n-calendar-title-color-hover": kt,
        "--n-calendar-title-height": yt,
        "--n-calendar-title-padding": Pt,
        "--n-calendar-title-font-size": n,
        "--n-calendar-title-font-weight": ct,
        "--n-calendar-title-text-color": it,
        "--n-calendar-title-grid-template-columns": St,
        "--n-calendar-days-height": Tt,
        "--n-calendar-days-divider-color": dt,
        "--n-calendar-days-font-size": i,
        "--n-calendar-days-text-color": Rt,
        "--n-calendar-divider-color": wt,
        // panel action
        "--n-panel-action-padding": ft,
        "--n-panel-extra-footer-padding": mt,
        "--n-panel-action-divider-color": lt,
        // panel item
        "--n-item-font-size": C,
        "--n-item-border-radius": Ze,
        "--n-item-size": ht,
        "--n-item-cell-width": gt,
        "--n-item-cell-height": vt,
        "--n-item-text-color": T,
        "--n-item-color-included": c,
        "--n-item-color-disabled": R,
        "--n-item-color-hover": Qe,
        "--n-item-color-active": Xe,
        "--n-item-text-color-disabled": et,
        "--n-item-text-color-active": tt,
        // scroll item
        "--n-scroll-item-width": pt,
        "--n-scroll-item-height": Ct,
        "--n-scroll-item-border-radius": It,
        // panel arrow
        "--n-arrow-size": Ft,
        "--n-arrow-color": rt,
        // icon in trigger
        "--n-icon-color": Dt,
        "--n-icon-color-disabled": bt
      };
    }), b = U ? de("date-picker", s(() => t.type), le, t) : void 0;
    return Object.assign(Object.assign({}, Je), {
      mergedStatus: ve,
      mergedClsPrefix: B,
      mergedBordered: pe,
      namespace: Ce,
      uncontrolledValue: Y,
      pendingValue: u,
      panelInstRef: L,
      triggerElRef: G,
      inputInstRef: F,
      isMounted: Jt(),
      displayTime: x,
      displayStartTime: E,
      displayEndTime: z,
      mergedShow: h,
      adjustedTo: ge(t),
      isRange: ee,
      localizedStartPlaceholder: Ve,
      localizedEndPlaceholder: we,
      mergedSize: M,
      mergedDisabled: l,
      localizedPlacehoder: Fe,
      isValueInvalid: re.isValueInvalidRef,
      isStartValueInvalid: N.isStartValueInvalidRef,
      isEndValueInvalid: N.isEndValueInvalidRef,
      handleInputKeydown: ze,
      handleClickOutside: je,
      handleKeydown: Ee,
      handleClear: Me,
      handlePanelClear: Ue,
      handleTriggerClick: Le,
      handleInputActivate: Ne,
      handleInputDeactivate: Ke,
      handleInputFocus: Ge,
      handleInputBlur: qe,
      handlePanelTabOut: Ae,
      handlePanelClose: Be,
      handleRangeUpdateValue: We,
      handleSingleUpdateValue: $e,
      handlePanelUpdateValue: He,
      handlePanelConfirm: ae,
      mergedTheme: A,
      actions: Se,
      triggerCssVars: U ? void 0 : ie,
      triggerThemeClass: D == null ? void 0 : D.themeClass,
      triggerOnRender: D == null ? void 0 : D.onRender,
      cssVars: U ? void 0 : le,
      themeClass: b == null ? void 0 : b.themeClass,
      onRender: b == null ? void 0 : b.onRender,
      onNextMonth: t.onNextMonth,
      onPrevMonth: t.onPrevMonth,
      onNextYear: t.onNextYear,
      onPrevYear: t.onPrevYear
    });
  },
  render() {
    const {
      clearable: t,
      triggerOnRender: O,
      mergedClsPrefix: d,
      $slots: r
    } = this, f = {
      onUpdateValue: this.handlePanelUpdateValue,
      onTabOut: this.handlePanelTabOut,
      onClose: this.handlePanelClose,
      onClear: this.handlePanelClear,
      onKeydown: this.handleKeydown,
      onConfirm: this.handlePanelConfirm,
      ref: "panelInstRef",
      value: this.pendingValue,
      active: this.mergedShow,
      actions: this.actions,
      shortcuts: this.shortcuts,
      style: this.cssVars,
      defaultTime: this.defaultTime,
      themeClass: this.themeClass,
      panel: this.panel,
      inputReadonly: this.inputReadonly || this.mergedDisabled,
      onRender: this.onRender,
      onNextMonth: this.onNextMonth,
      onPrevMonth: this.onPrevMonth,
      onNextYear: this.onNextYear,
      onPrevYear: this.onPrevYear,
      timePickerFormat: this.timePickerFormat,
      dateFormat: this.dateFormat,
      calendarDayFormat: this.calendarDayFormat,
      calendarHeaderYearFormat: this.calendarHeaderYearFormat,
      calendarHeaderMonthFormat: this.calendarHeaderMonthFormat,
      calendarHeaderMonthYearSeparator: this.calendarHeaderMonthYearSeparator,
      calendarHeaderMonthBeforeYear: this.calendarHeaderMonthBeforeYear
    }, P = () => {
      const {
        type: l
      } = this;
      return l === "datetime" ? o(Ut, Object.assign({}, f, {
        defaultCalendarStartTime: this.defaultCalendarStartTime
      }), r) : l === "daterange" ? o(Mt, Object.assign({}, f, {
        defaultCalendarStartTime: this.defaultCalendarStartTime,
        defaultCalendarEndTime: this.defaultCalendarEndTime,
        bindCalendarMonths: this.bindCalendarMonths
      }), r) : l === "datetimerange" ? o(At, Object.assign({}, f, {
        defaultCalendarStartTime: this.defaultCalendarStartTime,
        defaultCalendarEndTime: this.defaultCalendarEndTime,
        bindCalendarMonths: this.bindCalendarMonths
      }), r) : l === "month" || l === "year" || l === "quarter" ? o(jt, Object.assign({}, f, {
        type: l,
        key: l
      })) : l === "monthrange" || l === "yearrange" || l === "quarterrange" ? o(Bt, Object.assign({}, f, {
        type: l
      })) : o(zt, Object.assign({}, f, {
        type: l,
        defaultCalendarStartTime: this.defaultCalendarStartTime
      }), r);
    };
    if (this.panel)
      return P();
    O == null || O();
    const M = {
      bordered: this.mergedBordered,
      size: this.mergedSize,
      passivelyActivated: !0,
      disabled: this.mergedDisabled,
      readonly: this.inputReadonly || this.mergedDisabled,
      clearable: t,
      onClear: this.handleClear,
      onClick: this.handleTriggerClick,
      onKeydown: this.handleInputKeydown,
      onActivate: this.handleInputActivate,
      onDeactivate: this.handleInputDeactivate,
      onFocus: this.handleInputFocus,
      onBlur: this.handleInputBlur
    };
    return o("div", {
      ref: "triggerElRef",
      class: [`${d}-date-picker`, this.mergedDisabled && `${d}-date-picker--disabled`, this.isRange && `${d}-date-picker--range`, this.triggerThemeClass],
      style: this.triggerCssVars,
      onKeydown: this.handleKeydown
    }, o(ia, null, {
      default: () => [o(la, null, {
        default: () => this.isRange ? o(ue, Object.assign({
          ref: "inputInstRef",
          status: this.mergedStatus,
          value: [this.displayStartTime, this.displayEndTime],
          placeholder: [this.localizedStartPlaceholder, this.localizedEndPlaceholder],
          textDecoration: [this.isStartValueInvalid ? "line-through" : "", this.isEndValueInvalid ? "line-through" : ""],
          pair: !0,
          onUpdateValue: this.handleRangeUpdateValue,
          theme: this.mergedTheme.peers.Input,
          themeOverrides: this.mergedTheme.peerOverrides.Input,
          internalForceFocus: this.mergedShow,
          internalDeactivateOnEnter: !0
        }, M), {
          separator: () => this.separator === void 0 ? q(r.separator, () => [o(K, {
            clsPrefix: d,
            class: `${d}-date-picker-icon`
          }, {
            default: () => o(ta, null)
          })]) : this.separator,
          [t ? "clear-icon-placeholder" : "suffix"]: () => q(r["date-icon"], () => [o(K, {
            clsPrefix: d,
            class: `${d}-date-picker-icon`
          }, {
            default: () => o(me, null)
          })])
        }) : o(ue, Object.assign({
          ref: "inputInstRef",
          status: this.mergedStatus,
          value: this.displayTime,
          placeholder: this.localizedPlacehoder,
          textDecoration: this.isValueInvalid && !this.isRange ? "line-through" : "",
          onUpdateValue: this.handleSingleUpdateValue,
          theme: this.mergedTheme.peers.Input,
          themeOverrides: this.mergedTheme.peerOverrides.Input,
          internalForceFocus: this.mergedShow,
          internalDeactivateOnEnter: !0
        }, M), {
          [t ? "clear-icon-placeholder" : "suffix"]: () => o(K, {
            clsPrefix: d,
            class: `${d}-date-picker-icon`
          }, {
            default: () => q(r["date-icon"], () => [o(me, null)])
          })
        })
      }), o(oa, {
        show: this.mergedShow,
        containerClass: this.namespace,
        to: this.adjustedTo,
        teleportDisabled: this.adjustedTo === ge.tdkey,
        placement: this.placement
      }, {
        default: () => o(da, {
          name: "fade-in-scale-up-transition",
          appear: this.isMounted
        }, {
          default: () => this.mergedShow ? ra(P(), [[Qt, this.handleClickOutside, void 0, {
            capture: !0
          }]]) : null
        })
      })]
    }));
  }
});
export {
  Qa as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/date-picker/src/DatePicker.js
// module id = 459
// module chunks = 41